import { useAppReviewContext } from "core/state/AppReviewContext/AppReviewContext";
import { Modal } from "shared/UI/Modal/Modal";
import { ReactComponent as CrossIcon } from "shared/assets/Icons/cross.svg";
import { Controller, useForm } from "react-hook-form";
import { Textarea } from "shared/UI/Textarea/Textarea";
import Button from "shared/UI/Buttons/Button";
import { useStatusModal } from "shared/core/hooks/useStatusModal";
import { useTranslation } from "react-i18next";

export const FeedbackModal = () => {
  const { t } = useTranslation();
  const { isFeedbackModalVisible, handleSubmitFeedback, handleDismissFeedback } = useAppReviewContext();
  const { Modal: StatusModal, setBody } = useStatusModal("feedback-submit-status");

  const {
    control,
    handleSubmit,
    getValues,
    reset,
    formState: { dirtyFields },
  } = useForm({
    defaultValues: {
      feedback: "",
    },
  });

  async function onSubmit() {
    const { feedback } = getValues();
    handleSubmitFeedback(feedback);
    reset();
    setBody({
      data: {
        title: t("app-review.feedback.successMessage"),
      },
      status: "success",
      dismissAfter: 2000,
      dismissCallback: () => setBody(null),
    });
  }

  if (!isFeedbackModalVisible) return <>{StatusModal}</>;

  return (
    <Modal width="xs">
      <div data-testid="feedback-modal" className="relative p-6">
        <button
          data-testid="feedback-modal-dismissed"
          aria-label={t("app-review.feedback.dismiss")}
          onClick={handleDismissFeedback}
          className="absolute z-10 w-4 h-4 top-4 right-4"
        >
          <CrossIcon className="fill-brand-grey hover:fill-brand-grey-light" />
        </button>
        <div className="space-y-4 py-2">
          <h2>{t("app-review.feedback.title")}</h2>
          <p>{t("app-review.feedback.description")}</p>
          <form className="space-y-8" onSubmit={handleSubmit(onSubmit)}>
            <Controller
              name={"feedback"}
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, value } }) => (
                <div className="text-font-dark">
                  <Textarea
                    id="feedback"
                    maxLength={1000}
                    rows={10}
                    placeholder={t("app-review.feedback.placeholder")}
                    aria-label={t("app-review.feedback.aria-label")}
                    onChange={onChange}
                    value={value}
                  />
                </div>
              )}
            />

            <Button type="submit" disabled={!dirtyFields.feedback} text={t("app-review.feedback.cta")} />
          </form>
        </div>
      </div>
    </Modal>
  );
};
